import { get } from 'helpers/api';

export async function openWorkramp(path?: string): Promise<void> {
  if (!path) return;

  const response = await get(`${path}?accessing_from_mobile=false`);

  if (response?.loginUrl) window.open(response.loginUrl, '_blank');
}
